var _defs, _polygon, _polyline, _polyline2, _polyline3, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _polyline4, _ellipse3, _ellipse4, _ellipse5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse6, _path23, _path24, _path25, _path26, _ellipse7, _ellipse8, _line, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 231.39,
    y1: 208.74,
    x2: 257.34,
    y2: 181.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 76.05,
    y1: 206.49,
    x2: 119.1,
    y2: 169.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 142.09,
    y1: 245.41,
    x2: 175.28,
    y2: 216.64,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "61-70") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "45.53 195.47 173.01 270.66 363.98 158.32 235.8 84.4 45.53 195.47",
    fill: "#f88949"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "266.56 201.07 234.22 220.93 207.67 204.54 248.98 181.86",
    opacity: 0.32,
    fill: "url(#linear-gradient)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "134.2 184.09 83.4 214.37 54.43 197.24 99.89 168.98",
    opacity: 0.32,
    fill: "url(#linear-gradient-2)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "186.47 227.6 147.09 251.89 125.88 238.8 167.19 216.12",
    opacity: 0.32,
    fill: "url(#linear-gradient-3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.46,54.24,202.84,42.3a5.25,5.25,0,0,0-1.79-.94h0a5.09,5.09,0,0,0-4,.47L96.31,99.28a5.17,5.17,0,0,0-2.61,4.52l.49,68.59a5.09,5.09,0,0,0,1.65,3.75h0a5.25,5.25,0,0,0,2.28,1.23l22.25,12s8.47-20.1,3.89-24.33a2.58,2.58,0,0,0-1-.56l79-45.82a5.17,5.17,0,0,0,2.57-4.47V62.74l.7,4Z",
    fill: "#68e1fd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.46,54.24,202.84,42.3a5.25,5.25,0,0,0-1.79-.94h0a5.09,5.09,0,0,0-4,.47L96.31,99.28a5.17,5.17,0,0,0-2.61,4.52l.49,68.59a5.09,5.09,0,0,0,1.65,3.75h0a5.25,5.25,0,0,0,2.28,1.23l22.25,12s8.47-20.1,3.89-24.33a2.58,2.58,0,0,0-1-.56l79-45.82a5.17,5.17,0,0,0,2.57-4.47V62.74l.7,4Z",
    fill: "#272322",
    opacity: 0.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34,111.78,219.82,53.89a5.17,5.17,0,0,1,7.74,4.45l.29,67.88a5.17,5.17,0,0,1-2.55,4.48l-100,58.59a5.17,5.17,0,0,1-7.78-4.4l-.78-68.58A5.17,5.17,0,0,1,119.34,111.78Z",
    fill: "#68e1fd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34,111.78,219.82,53.89a5.17,5.17,0,0,1,7.74,4.45l.29,67.88a5.17,5.17,0,0,1-2.55,4.48l-100,58.59a5.17,5.17,0,0,1-7.78-4.4l-.78-68.58A5.17,5.17,0,0,1,119.34,111.78Z",
    fill: "#fff",
    opacity: 0.37
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.63,
    cy: 87.83,
    rx: 5.73,
    ry: 2.49,
    fill: "#272322"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.11,
    cy: 68.6,
    rx: 5.73,
    ry: 2.49,
    fill: "#272322"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.41,67.2a7.51,7.51,0,0,0,.21,2.07c1.4.35,3-.66,4.37-.85,1.84-.25,6,1.76,6.85.18,0-2.43-.86-7.31-2.81-9-4-3.43-9.87-1.08-13.81,1-2.56,1.33-5.1,2.72-7.63,4.1q-4.66,2.56-9.29,5.16c-2.86,1.6-5.58,3.39-8.58,4.74a17.79,17.79,0,0,0-3.62,2.13,13,13,0,0,0-5.19,11.12h11.46V82.69a4.43,4.43,0,0,1,2-4.32c2.49-1.66,23.7-13,24.84-12.64S171.25,65.91,171.41,67.2Z",
    fill: "#272322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.16,179.56v5.3a5,5,0,0,1-1.39,2.54c-1.08.91-5.46,2.79-5.38,7.11.07,3.88-.08,30.22-.08,30.22H189V194.51s-1-4.52-4.16-6.7a8.28,8.28,0,0,1-2-1.5c-.92-1.18-.45-2.6-.31-4.61a23.24,23.24,0,0,0-.11-2.66",
    fill: "#603316"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "162.78 173.87 162.78 179.33 184.38 179.33 184.38 173.87",
    fill: "#dbdbdb"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.58,
    cy: 179.33,
    rx: 10.8,
    ry: 4.75,
    fill: "#dbdbdb"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.58,
    cy: 173.87,
    rx: 10.8,
    ry: 4.75,
    fill: "#ededed"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.17,
    cy: 224.29,
    rx: 15.86,
    ry: 6.08,
    fill: "#603316"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189,195.8c-.41.08-12.79,4.55-24.41,1.55v20.86s13.53,4.92,24.41-1.8Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.94,104.45s.62-28.76,1.86-32.06,3.68-13.95,4.89-15.22,2.16-5.88,6.31-4.78A42.87,42.87,0,0,1,260.57,55L255.4,84.4l-2.18,20.93Z",
    fill: "#eef3f7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.69,91.17c-5,.38-14.13-14.21-14.13-14.21,5.08-2.69,5.31-8.57,5.31-8.57l12.51,11.52",
    fill: "#dbdbdb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M221.57,77s-2.37-.5-.53-4.92,4.51-4.88,5.85-3.65S226.11,77.3,221.57,77Z",
    fill: "#9e9e9e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M223.19,76.86a8.28,8.28,0,0,0,3.75-4.81,4.42,4.42,0,0,1-.51-.79c.09-.7.18-1.39.24-2.09a23,23,0,0,1,1.55-5.54c.48-1.37-1.69-2-2.17-.6a37.6,37.6,0,0,0-1.35,4.12l-.75-8c-.13-1.43-2.38-1.44-2.25,0l.53,5.65c-.29-2-.54-4.09-.71-6.14-.12-1.43-2.37-1.44-2.25,0,0,.37.07.74.11,1.11-.7-.35-1.7-.06-1.6.92.06.58.13,1.17.2,1.75a1.17,1.17,0,0,0-1.25,1.4C217.79,68.77,219.7,73.35,223.19,76.86Z",
    fill: "#f0b387"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M245.47,171.54s-.62,8.37-2.07,9.6-7.21,5.65-8.2,6.37-.05,3.11,3.35,3.11,9.9-4,9.9-4l4.8-1.78s.67-8.11-.36-13.1S245.47,171.54,245.47,171.54Z",
    fill: "#4a2b0f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M261.7,185.07s-3.38,16.32-1.16,17.58,7.24-1.45,8-4.25.48-19.41,0-19.51",
    fill: "#4a2b0f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M240.94,114.16l.84,60.56s7.47,2.54,14.55,0l-1.4-57.35L259,187.83a16.44,16.44,0,0,0,12.67,0L270.4,109l-28.62-7.93Z",
    fill: "#68e1fd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.39,52.27S243.53,50,239.69,59c-5.21,12.15-5.47,81.65-5.47,81.65a18.22,18.22,0,0,0,8.59,4.69s.67-71.73,1.24-76.26C245,61.6,251.39,52.27,251.39,52.27Z",
    fill: "#dbdbdb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M245.39,52.82s-4.43,5.27-4.1,5.27,1.59,1.59,1.59,1.59l-2.51,2.42,3.21,34s-2.33-24.67,7.82-43.73C251.41,52.33,247.06,51.81,245.39,52.82Z",
    fill: "#eef3f7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M258.94,54.29s7.87,2.74,9.92,10c2.11,7.45,2.44,82.45,2.44,83.24s-5,3.92-9.23,4.54-10.44-1.78-10.44-1.78l-1.13-43.74s.54-25.14,1.13-29.93S258.94,54.29,258.94,54.29Z",
    fill: "#dbdbdb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.52,114.79q-.36-18.6-.33-37.2a.65.65,0,0,0-1.3,0q-.06,18.77.34,37.54Z",
    fill: "#9e9e9e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M259.79,138.25S276.92,122,278.12,122.7s1.08,25.36.84,26.08-12,12.8-13.42,13.16-6.91,0-6.91,0Z",
    fill: "#4a2b0f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M265,135.66s-2-10.92,3.83-13,4.31,6.38,4.31,6.38l2.05-2.42s-.48-8.39-6.67-6.16-7.11,10.41-6.09,16.5",
    fill: "#4a2b0f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M271,112.26a17.79,17.79,0,0,1-6.8,2.38,22.86,22.86,0,0,1-1.89,4.9c-.43,1.9-.48,3.75,1.47,3.55a.65.65,0,0,0,.54-.4c.06.52.12,1,.19,1.56a.48.48,0,0,0,.15.26,1,1,0,0,0,1.1.68.86.86,0,0,0,.44-.17,1.09,1.09,0,0,0,.78.93.94.94,0,0,0,1.15-.51,1.19,1.19,0,0,0,1.51.46,1.51,1.51,0,0,0,.72-.88.6.6,0,0,0,.26-.24c1.51-2.62,1.22-5.47.46-8.26C271.06,115.11,271,113.68,271,112.26Z",
    fill: "#f0b387"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M258.94,54l3.13,1.83-1.18,6.6-3.84.51,1.25,3.68s-4.11,9.07-4.82,10.61-2.67,16.6-2.67,16.6.46-16.31,1-18.38S255.18,60.24,258.94,54Z",
    fill: "#eef3f7"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.04,
    cy: 66.5,
    rx: 2.34,
    ry: 2.61,
    transform: "translate(-8.78 74.17) rotate(-16.98)",
    fill: "#9e9e9e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M244.63,64.89c-.22-.15.18-14.07,8.22-13.23s7.38,6.8,7.08,9.87l1.29.18s1.51-10.64-8.76-10.67-8.6,14.71-8.6,14.71",
    fill: "#9e9e9e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246.29,44.61A4.52,4.52,0,0,1,244,40.38c0-3.19,4.94-5.59,7-5.88,2.62-.37,11.36.72,11.89,7.24.38,4.54-2.73,12.6-5,12.66",
    fill: "#4a2b0f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.31,49.93a29.36,29.36,0,0,0-.83-3q-.17-.51-.36-1c-.62-1.61-1.57-1.13-3-1.13a13.63,13.63,0,0,1-3.34-.34,18,18,0,0,1-4.76-2c-.22,3.5-.36,13.77,5.33,14.65,3.46.54,5.35-.83,6.41-2.47C257.95,53,258.13,51.48,258.31,49.93Z",
    fill: "#f0b387"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M257.06,49.51s1.38-3.49,2.43-1.76c1.16,1.93-1.33,3.28-1.33,3.28",
    fill: "#f0b387"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.07,
    cy: 48.3,
    rx: 2.28,
    ry: 2.72,
    transform: "translate(-3.33 74.26) rotate(-16.98)",
    fill: "none",
    stroke: "#42210b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.22,
    cy: 49.79,
    rx: 2.28,
    ry: 2.72,
    transform: "translate(-3.5 76.12) rotate(-16.98)",
    fill: "none",
    stroke: "#42210b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 255.4,
    y1: 49.12,
    x2: 259.93,
    y2: 46.05,
    fill: "none",
    stroke: "#42210b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M249.52,49s1.09,0,1.39.38",
    fill: "none",
    stroke: "#42210b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M259.92,74.58c1.24,0,3.22,0,4.28-.7s.89-1.63.78-2.86c-.25-2.86-.48-8.16-3.76-9.32-2.86-1-5.27,1.08-6.29,3.58-.66,1.63-1.74,4.29-1.33,6.12.32,1.44,1.88,2.21,3.14,2.76.24.1.44-.24.2-.35-1.47-.64-3-1.5-2.94-3.3a15.91,15.91,0,0,1,1.1-4.56c1-2.68,3.59-5.17,6.5-3.6,2.38,1.28,2.65,5.82,2.92,8.16.18,1.53.37,2.52-1.33,3.27a9.54,9.54,0,0,1-3.28.39c-.26,0-.26.41,0,.4Z",
    fill: "#4d4d4d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M256,73.59c0,.22-.3.58,0,.73s1.28.58,1.37.26.24-.81,0-1S256,72.87,256,73.59Z",
    fill: "#4a2b0f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M259.39,74.29c0,.21-.17.63.16.71s1.37.29,1.39,0,.06-.84-.21-1S259.23,73.58,259.39,74.29Z",
    fill: "#4a2b0f"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M219.41,67.07a3.51,3.51,0,0,1,3.92-.38.23.23,0,0,0,.24-.4,4,4,0,0,0-4.48.45c-.24.19.1.51.33.33Z",
    fill: "#42210b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M224.16,67.52a4,4,0,0,0-2.39,4.13c0,.3.48.3.47,0a3.58,3.58,0,0,1,2-3.68c.28-.11.16-.56-.12-.45Z",
    fill: "#42210b"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M221.59,59.84l.53,5.7c0,.3.5.3.47,0l-.53-5.7c0-.3-.5-.3-.47,0Z",
    fill: "#42210b"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M219.26,60.52l.76,4.69c0,.3.5.17.45-.12l-.76-4.69c0-.3-.5-.17-.45.12Z",
    fill: "#42210b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M217.84,63.21l.87,2.39c.1.28.55.16.45-.12l-.87-2.39c-.1-.28-.55-.16-.45.12Z",
    fill: "#42210b"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M270.14,111.51a24.34,24.34,0,0,1-8.38,3c-.82.13-.47,1.38.34,1.25a25.33,25.33,0,0,0,8.69-3.12A.65.65,0,0,0,270.14,111.51Z",
    fill: "#9e9e9e"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.63 99.71 164.63 147.99 181.49 137.65 181.49 90.41 164.63 99.71",
    fill: "#f15a24"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "153.11 121.8 153.11 138.17 193.01 114.78 193.01 98.68 153.11 121.8",
    fill: "#f15a24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor8);
export default __webpack_public_path__ + "static/media/doctor8.b004d7154f72bd5c70be1cd887af6d5f.svg";
export { ForwardRef as ReactComponent };